import * as React from "react";
import { useState, useEffect } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';


const getUrl = window.location;
const baseUrl = getUrl.protocol + "//" + getUrl.host;

const pages = [
   { name: "overview", link: `${baseUrl}/events/summer22` },
   { name: "investors", link: `${baseUrl}/events/summer22/#custom-stop` },
   { name: "agenda", link: `${baseUrl}/events/summer22/agenda` },
   { name: "sponsors", link: `${baseUrl}/events/summer22/sponsors` },
   { name: "press", link: `${baseUrl}/events/summer22/press-passes` },
   { name: "venue", link: `${baseUrl}/events/summer22/venue` },
   { name: "matchmaking", link: `${baseUrl}/events/summer22/matchmaking` },
];
const settings = ["Profile", "Account", "Dashboard", "Logout"];


export const NavBarTest = () => {
   const [open, setOpen] = useState(false);
   const [anchorElNav, setAnchorElNav] = useState(null);
   const [anchorElUser, setAnchorElUser] = useState(null);
   const [chevron, setChevron] = useState(0);
   const [chevron2, setChevron2] = useState(0);
   const [chevron3, setChevron3] = useState(0);
   const [chevron4, setChevron4] = useState(0);
   const [margin1, setMargin1] = useState("0vw");
   const [margin2, setMargin2] = useState("0vw");
   const [margin3, setMargin3] = useState("0vw");
   const [margin4, setMargin4] = useState("0vw");

   useEffect(() => {
      const script = document.createElement('script');
      script.src = 'https://js.hsforms.net/forms/v2.js';
      document.body.appendChild(script);

      script.addEventListener('load', () => {
         if (window.hbspt) {
            window.hbspt.forms.create({
               portalId: '536350',
               formId: '5f67c12f-e4b9-4386-950a-ce96f986918f',
               target: '#preregisterForm'
            })
         }
      });
   }, [open]);

   const handleOpenNavMenu = (event) => {
      setAnchorElNav(event.currentTarget);
   };

   const handleCloseNavMenu = () => {
      setAnchorElNav(null);
   };

   const handleCloseUserMenu = () => {
      setAnchorElUser(null);
   };

   const handleClose = () => {
      setOpen(false);
   };


   return (
      <>
         <AppBar
            position="sticky"
            sx={{
               backgroundColor: "black",
               m: 0,
               width: "100%",
               fontFamily: "Poppins, sans-serif !important",
            }}
         >
            <Container maxWidth="xl" sx={{ margin: "auto" }}>
               <Toolbar disableGutters={true}>
                  <Typography
                     variant="h6"
                     noWrap
                     component="div"
                     sx={{
                        mr: 2,
                        flex: 1,
                        fontFamily: "Poppins, sans-serif !important",
                        display: { xs: "none", md: "flex" },
                     }}
                  >
                     <div style={{ display: "flex", alignItems: "center", gap: "5%" }}>
                        <a href="https://youngstartup.com/upcoming"><img
                           alt='youngstartup'
                           src="./assets/media/Nav Bar Logo.png"
                           style={{ objectFit: "scale-down", width: '100%', maxWidth: "350px", minWidth: "150px", padding: '.5%' }}
                        /></a>
                        {/* <Stack>
                <div style={{display:'flex', height:'fit-content'}}>July 19-20</div>
                <div style={{display:'flex', height:'fit-content'}}>Hyatt Regency</div>
              </Stack> */}
                     </div>
                  </Typography>

                  <Box
                     sx={{ flex: 1, flexGrow: 1, display: { xs: "flex", md: "none" } }}
                  >
                     <IconButton
                        size="large"
                        aria-label="account of current user"
                        aria-controls="menu-appbar"
                        aria-haspopup="true"
                        onClick={handleOpenNavMenu}
                        color="inherit"
                     >
                        <MenuIcon />
                     </IconButton>
                     <Menu
                        id="menu-appbar"
                        anchorEl={anchorElNav}
                        anchorOrigin={{
                           vertical: "bottom",
                           horizontal: "left",
                        }}
                        keepMounted
                        transformOrigin={{
                           vertical: "top",
                           horizontal: "left",
                        }}
                        open={Boolean(anchorElNav)}
                        onClose={handleCloseNavMenu}
                        sx={{
                           display: { xs: "block", md: "none" },
                        }}
                     >
                        {pages.map((page) => (
                           <MenuItem
                              key={page.name}
                              onClick={handleCloseNavMenu}
                              sx={{ backgroundColor: "black" }}
                           >
                              <a href={page.link}>
                                 <Typography
                                    textAlign="center"
                                    sx={{
                                       fontFamily: "Poppins, sans-serif !important",
                                       color: "white",
                                    }}
                                 >
                                    {page.name}
                                 </Typography>
                              </a>
                           </MenuItem>
                        ))}
                        <MenuItem sx={{ backgroundColor: 'black' }}>
                           <a href={`${baseUrl}/events/summer22/registration`} style={{ width: '100%' }}>
                              <button
                                 onMouseOver={(e) => {
                                    setChevron3(1);
                                    setMargin3("1.5vw");
                                    
                                 }}
                                 onMouseLeave={() => {
                                    setChevron3(0);
                                    setMargin3("0vw");
                                 }}
                                 className="dark-btn-red"
                                 style={{
                                    marginRight: "1rem",
                                    fontWeight: "900",
                                    fontSize: "18px",
                                    width: '100%'
                                 }}
                              >
                                 <div style={{ display: "flex", alignItems: "center" }}>
                                    <ChevronRightIcon sx={{ opacity: "0" }} />
                                    <div>Register</div>
                                    <ChevronRightIcon
                                       sx={{
                                          transition: ".3s all ease-in-out",
                                          opacity: chevron3,
                                          marginLeft: margin3,
                                       }}
                                    />
                                 </div>
                              </button>
                           </a>
                        </MenuItem>
                        <MenuItem sx={{ backgroundColor: 'black' }}>
                           <a href={`${baseUrl}/events/summer22/top-innovators`} style={{ width: '100%' }}>
                              {/* <Button className="dark-btn-red" sx={{borderRadius:'0px', backgroundColor:'#7C2387', fontFamily: 'Poppins, sans-serif !important', "&:hover":{backgroundColor:'#7C2387'}}} variant="contained">Register</Button> */}
                              <button
                                 onMouseOver={(e) => {
                                    setChevron4(1);
                                    setMargin4("1.5vw");
                                    
                                 }}
                                 onMouseLeave={() => {
                                    setChevron4(0);
                                    setMargin4("0vw");
                                 }}
                                 className="dark-btn-red"
                                 style={{
                                    marginRight: "1rem",
                                    fontWeight: "900",
                                    fontSize: "18px",
                                    width: '100%'
                                 }}
                              >
                                 <div style={{ display: "flex", alignItems: "center" }}>
                                    <ChevronRightIcon sx={{ opacity: "0" }} />
                                    <div>Present</div>{" "}
                                    <ChevronRightIcon
                                       sx={{
                                          transition: ".3s all ease-in-out",
                                          opacity: chevron4,
                                          marginLeft: margin4,
                                       }}
                                    />
                                 </div>
                              </button>
                           </a>
                        </MenuItem>
                     </Menu>
                  </Box>
                  <Typography
                     variant="h6"
                     noWrap
                     component="div"
                     sx={{
                        flexGrow: 1,
                        display: {
                           xs: "flex",
                           md: "none",
                           fontFamily: "Poppins, sans-serif !important",
                        },
                     }}
                  >
                     <div style={{ display: "flex", alignItems: "center", gap: '5%' }}>
                        <a href="https://youngstartup.com/upcoming"><img
                           alt='youngstartup'
                           src="./assets/media/Nav Bar Logo.png"
                           style={{ objectFit: "scale-down", minWidth: "150px", maxWidth: "250px" }}
                        /></a>
                        {/* <div style={{ display: "flex", flexDirection: "column" }}>
                <h5
                  style={{
                    fontFamily: "Poppins, sans-serif !important",
                    fontSize: ".65rem",
                    margin: "0 !important",
                  }}
                >
                  July 19-20<br/>
                  Hyatt Regency
                </h5>
              </div> */}
                     </div>
                  </Typography>
                  <Box
                     sx={{
                        flex: 1,
                        ml: 15,
                        display: { xs: "none", md: "flex", justifyContent: "left" },
                     }}
                  >
                     {pages.map((page) => (
                        <a href={page.link}>
                           <Button
                              key={page.name}
                              onClick={handleCloseNavMenu}
                              sx={{
                                 mr: 2,
                                 borderBottom: (window.location.href === page.link || window.location.href === `${page.link}/`) ? "2px solid #FF2945" : "white",
                                 color: 'white',
                                 display: "block",
                                 fontFamily: "Poppins, sans-serif !important",
                                 borderRadius: "0px",
                                 "&:hover": { color: "#D71325" },
                              }}
                           >
                              {page.name}
                           </Button>
                        </a>
                     ))}
                  </Box>

                  <Box
                     sx={{ flex: 1, display: window.innerWidth < 1000 ? "none" : "" }}
                  >
                     <div
                        style={{ display: "flex", gap: "25px", justifyContent: "right" }}

                     >
                        <a href={`${baseUrl}/events/summer22/registration`}>
                           <button
                              onMouseOver={(e) => {
                                 setChevron(1);
                                 setMargin1("1.5vw");
                                 
                              }}
                              onMouseLeave={() => {
                                 setChevron(0);
                                 setMargin1("0vw");
                              }}
                              className="dark-btn-red"
                              style={{
                                 marginRight: "1rem",
                                 fontWeight: "900",
                                 fontSize: "18px",
                              }}
                           >
                              <div style={{ display: "flex", alignItems: "center" }}>
                                 <ChevronRightIcon sx={{ opacity: "0" }} />
                                 <div>REGISTER</div>
                                 <ChevronRightIcon
                                    sx={{
                                       transition: ".3s all ease-in-out",
                                       opacity: chevron,
                                       marginLeft: margin1,
                                    }}
                                 />
                              </div>
                           </button>
                        </a>
                        {!window.location.href.includes("top-innovators") && <a href={`${baseUrl}/events/summer22/top-innovators`}>
                           <button
                              onMouseOver={(e) => {
                                 setChevron2(1);
                                 setMargin2("1.5vw");
                                 
                              }}
                              onMouseLeave={() => {
                                 setChevron2(0);
                                 setMargin2("0vw");
                              }}
                              className="dark-btn-red"
                              style={{
                                 marginRight: "1rem",
                                 fontWeight: "900",
                                 fontSize: "18px",
                              }}
                           >
                              <div style={{ display: "flex", alignItems: "center" }}>
                                 <ChevronRightIcon sx={{ opacity: "0" }} />
                                 <div>PRESENT</div>
                                 <ChevronRightIcon
                                    sx={{
                                       transition: ".3s all ease-in-out",
                                       opacity: chevron2,
                                       marginLeft: margin2,
                                    }}
                                 />
                              </div>
                           </button>
                        </a>}
                     </div>
                     <Menu
                        sx={{ mt: "45px" }}
                        id="menu-appbar"
                        anchorEl={anchorElUser}
                        anchorOrigin={{
                           vertical: "top",
                           horizontal: "right",
                        }}
                        keepMounted
                        transformOrigin={{
                           vertical: "top",
                           horizontal: "right",
                        }}
                        open={Boolean(anchorElUser)}
                        onClose={handleCloseUserMenu}
                     >
                        {settings.map((setting) => (
                           <MenuItem key={setting} onClick={handleCloseUserMenu}>
                              <Typography textAlign="center">{setting}</Typography>
                           </MenuItem>
                        ))}
                     </Menu>
                  </Box>
               </Toolbar>
            </Container>
         </AppBar>
         <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"

         >
            <DialogContent>
               <div id="preregisterForm"></div>
            </DialogContent>
         </Dialog>
      </>
   );
};
